import React, { useEffect, useState } from 'react';
import {BUILD_TYPE, getBuildType, setBuildType,} from '@voltmoney/micro-frontend';
import packageJson from './package.json';
import {ActivityIndicator, LogBox, Platform, Text, View} from 'react-native';
import WebPartnersApp from './web.partners';
import AppWeb from './AppWeb';
import PlatformDashboard from './platform_dashboard';
import { firebaseInit } from './utils';
import { fetchAndActivate, getBoolean } from 'firebase/remote-config';
import AsyncStorage from '@react-native-async-storage/async-storage';
import AppWebNew from './AppWebNew';
import defaultRemoteConfig from './defaults/default-remote-config-web.json'
import { getParameters } from '@app/utils';

LogBox.ignoreLogs([
  'DevTools failed to load source map',
  'Warning:',
  'Theme not initialized',
  'setNativeProps is deprecated',
  'Theme not initialized',
  'Warning: forwardRef render functions accept exactly two parameters',
  'Internal Server Error',
  'Manifest: Line: 1, column: 1, Syntax error.',
  "[Violation] Added non-passive event listener to a scroll-blocking 'wheel' event",
  'Uncaught TypeError:',
  'Warning: Invalid DOM property',
]);
console.info('*** App Version-> ', packageJson.version, getBuildType());

/*** Change the build type */
const buildType = BUILD_TYPE.PARTNER_STAGING;
setBuildType(buildType);
if (process.env.NODE_ENV === 'production' || getBuildType() === BUILD_TYPE.BORROWER_PRODUCTION|| buildType === BUILD_TYPE.BORROWER_PRODUCTION) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}
const BuildType: React.FunctionComponent = () => {

  const [isLoading, setIsLoading] = useState(true);
  const [useNewAppWeb, setUseNewAppWeb] = useState(false);
  const buildType = getBuildType();

  useEffect(() => {

    setIsLoading(true)

    if (Platform.OS === 'web') {
      const remoteConfig = firebaseInit();
      remoteConfig.defaultConfig = defaultRemoteConfig;
      async function fetchRemoteConfig() {
        try {
          await fetchAndActivate(remoteConfig);
          let newArchConfig = false; 
          let lmsRevampConfig = false;
          if(getBuildType() === BUILD_TYPE.BORROWER_PRODUCTION || buildType === BUILD_TYPE.BORROWER_PRODUCTION){// if production then check for show_new_arch else show_new_arch_dev
            newArchConfig = getBoolean(
              remoteConfig,
              'show_new_arch',
            );
            lmsRevampConfig = getBoolean(
              remoteConfig,
              'show_lms_revamp',
            );

          } else{
            newArchConfig = getBoolean(
              remoteConfig,
              'show_new_arch_dev',
            );
            lmsRevampConfig = getBoolean(
              remoteConfig,
              'show_lms_revamp_dev',
            );
          }
          // if(Platform.OS==="web"){
          //   const params = getParameters(window.location.href ) 
          //   const isPLJ = params?.plj;
          //   newArchConfig = Boolean(isPLJ) ? false : newArchConfig;
          // }
          await AsyncStorage.setItem('show_new_arch', `${newArchConfig}`)
          await AsyncStorage.setItem('show_lms_revamp', `${lmsRevampConfig}`)
          //@ts-ignore
          setUseNewAppWeb(newArchConfig)


        } catch (error) {
          console.error('Error fetching and activating remote config:', error);
        }
        finally {
          setIsLoading(false)
        }
      }
      fetchRemoteConfig();
    }
  }, []);

  if (isLoading) {
    return null
  }

  switch (buildType) {
    case BUILD_TYPE.BORROWER_STAGING:
    case BUILD_TYPE.BORROWER_PRODUCTION:
    case BUILD_TYPE.BORROWER_TEST_STAGING:
    case BUILD_TYPE.BORROWER_QA_STAGING:
    case BUILD_TYPE.BORROWER_LOS_STAGING:
    case BUILD_TYPE.BORROWER_LMS_STAGING:
      return useNewAppWeb ? <AppWebNew /> : <AppWeb />;
    case BUILD_TYPE.PARTNER_STAGING:
    case BUILD_TYPE.PARTNER_PRODUCTION:
      return <WebPartnersApp />;
    case BUILD_TYPE.PLATFORM_STAGING:
    case BUILD_TYPE.PLATFORM_PRODUCTION:
      return <PlatformDashboard />;
    default:
      return (
        <View style={{flex: 1}}>
          <Text>BuildType: {buildType} Not supported</Text>
        </View>
      );
  }
};

BuildType.propTypes = {};

export default BuildType;
